import {computed, defineComponent} from 'vue';
import {type RouteRecordRaw, useRoute} from "vue-router";
import {
    AdminHome,
    AdminSessions,
    AdminActorSearch,
    AdminInvoices,
    AdminSettings
} from "@/app/admin/admin-routes.ts";
import {IndexRoute} from "@/router/index-route.ts";

type AdminRoute = {
    route: RouteRecordRaw;
    isActive: boolean;
};

export default defineComponent({
    name: 'AegAdminHeader',
    setup() {
        const route = useRoute();
        
        const createAdminRoute = (routeConfig: RouteRecordRaw): AdminRoute => ({
            route: routeConfig,
            isActive: computed(() => route.name === routeConfig.name).value
        });

        const adminRoutes = computed(() => ({
            home: createAdminRoute(AdminHome),
            invoices: createAdminRoute(AdminInvoices),
            actors: createAdminRoute(AdminActorSearch),
            sessions: createAdminRoute(AdminSessions),
            settings: createAdminRoute(AdminSettings),
            account: createAdminRoute(IndexRoute)
        }));

        return {
            adminRoutes
        };
    }
})
